
import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import Adminheader from './Adminheader';
import Adminsidebar from './Adminsidebar';
import favicon from "../../images/chainpad/logo.png"
import { Dropdown, Nav, Tab, Row, Col, Container, ProgressBar, InputGroup, Form, FormControl } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import { FinalizeApproval, ProposalApproval } from '../../hooks/useVoting';



class Proposaledit extends Component {

    showLoader() {
        document.getElementsByTagName("body")[0].classList.add("overflow_hidden");
        document.getElementById("logo_overlay").style.opacity = 0.5;
        document.getElementById("loader_div").classList.remove("d-none");
        document.getElementById("loader_div").classList.add("d-block");


    }

    hideLoader() {
        document.getElementsByTagName("body")[0].classList.remove("overflow_hidden");
        document.getElementById("logo_overlay").style.opacity = 1;
        document.getElementById("loader_div").classList.remove("d-block");
        document.getElementById("loader_div").classList.add("d-none");
    }


    componentDidMount() {
        console.log("this.props.location?.state", this.props.location?.state);

        this.hideLoader();
        this.setState({ formdata: this.props.location?.state?.state });
    }


    ApproveVoting = async () => {
        try {
            let approveresult = await ProposalApproval({ pid: parseInt(this?.state?.formdata?._pid) });
            console.log("approveresultapproveresult", approveresult);

            if (approveresult?.type == "success") {
                console.log("Success");
                toast.success("Approved successfully")
                this.setState({ loader: false })
                this.props.history.push("/voting");
            }
            if (approveresult?.type == "error") {
                toast.error(approveresult?.message)
                this.setState({ loader: false })
            }
        }
        catch (e) {
            console.log("Error on approve voting", e);

        }
    }

    FinalisedVoting = async () => {
        try {
            let approveresult = await FinalizeApproval({ pid: parseInt(this?.state?.formdata?._pid) });
            if (approveresult?.type == "success") {
                console.log("Success");
                toast.success("Finalized successfully");
                this.setState({loader : false})
                this.props.history.push("/voting");
                // proposalrefetch();
            }
            if (approveresult?.type == "error") {
                toast.error(approveresult?.message);
                this.setState({loader : false})
            }
        }
        catch (e) {
            console.log("Error on approve voting", e);

        }
    }


    constructor(props) {
        super(props);
        this.state = {
            formdata: undefined,
            loader: false
        };
    }


    render() {

        console.log("formdata", this.state.formdata);


        return (

            <div id="loader_main">
                <div id="loader_div">
                    <span className="spin_round">

                    </span>
                    <img src={favicon} className="logo_load" />
                </div>

                <div className='logo_overlay' id="logo_overlay">
                    <Adminheader />

                    <div className="whole_sec pb-5">
                        <div className='flex_side_right adminisideright'>
                            <Adminsidebar />

                            <div className='right_side_sec adminside'>

                                <div className="right_side_spacing">

                                    <div className='ongoing_sec proj_bg pb-5'>

                                        <div className="container px-1">
                                            <div className='top_heqad_sec mt-5 mt-md-0'>
                                                <div className='col-12 col-md-12 px-1 text-start'>
                                                    <Link to="/voting"> <button className="get-started-btn mt-3">
                                                        Back
                                                    </button></Link>

                                                </div>
                                                <div className="row">
                                                    <div className="col-12 col-md-6 flex_cen_col mt-md-4 mb-md-4">
                                                        <p className="banner_subtitle form_subhead">Voting Edit</p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="inner_bg">
                                            <div className="container px-1">
                                                <Tab.Container defaultActiveKey="second">
                                                    <Row className="container-fluid w-100 mx-0 px-0">
                                                        <Col lg={12} className="img_center_lg px-0">
                                                            <div className='px-0'>
                                                                <Tab.Content>
                                                                    <Tab.Pane eventKey="second">
                                                                        <div className='row'>
                                                                            <div className='col-md-6 mb-4'>
                                                                                <p className='input_desc_sm'>Title</p>
                                                                                <div className="inputs input-groups">
                                                                                    <InputGroup className="">
                                                                                        <FormControl type="text" placeholder="Enter name" value={this.state.formdata?.title} readOnly

                                                                                        />

                                                                                    </InputGroup>
                                                                                    {/* <span className="text-danger f-12 d-block text-left">sdasdas</span> */}
                                                                                </div>
                                                                            </div>

                                                                            <div className='col-md-6 mb-4'>
                                                                                <p className='input_desc_sm'>Sub Title</p>
                                                                                <div className="inputs input-groups">
                                                                                    <InputGroup className="">
                                                                                        <FormControl type="text" placeholder="Enter subname" value={this.state.formdata?.title_slug} readOnly
                                                                                        />
                                                                                    </InputGroup>
                                                                                    {/* <span className="text-danger f-12 d-block text-left">sdasdas</span> */}
                                                                                </div>
                                                                            </div>

                                                                            <div className='col-md-6 mb-4'>
                                                                                <p className='input_desc_sm'>Short Description</p>
                                                                                <div className="inputs input-groups">
                                                                                    <InputGroup className="">
                                                                                        <FormControl as="textarea" placeholder="Description" rows={5} value={this.state.formdata?.shortDesc} readOnly
                                                                                        />
                                                                                    </InputGroup>
                                                                                    {/* <span className="text-danger f-12 d-block text-left">sdasdas</span> */}
                                                                                </div>
                                                                            </div>

                                                                            <div className='col-md-6 mb-4'>
                                                                                <p className='input_desc_sm'>Long Description</p>
                                                                                <div className="inputs input-groups">
                                                                                    <InputGroup className="">
                                                                                        <FormControl as="textarea" placeholder="Description" rows={5} value={this.state.formdata?.longDesc} readOnly
                                                                                        />
                                                                                    </InputGroup>
                                                                                    {/* <span className="text-danger f-12 d-block text-left">sdasdas</span> */}
                                                                                </div>
                                                                            </div>

                                                                            <div className='col-md-6 mb-4'>
                                                                                <p className='input_desc_sm'>Status</p>
                                                                                <div className="inputs input-groups">
                                                                                    <InputGroup className="">
                                                                                        <FormControl type="text" placeholder="Enter subname" value={this.state.formdata?.status == 0 ? "WAITING FOR APPROVAL"
                                                                                            : this.state.formdata?.status == 0 ? "APPROVED" : "FINALIZE"} readOnly
                                                                                        />
                                                                                    </InputGroup>
                                                                                    {/* <span className="text-danger f-12 d-block text-left">sdasdas</span> */}
                                                                                </div>
                                                                            </div>

                                                                            <div className='col-md-6 mb-4'>
                                                                                <p className='input_desc_sm'>Start Date</p>
                                                                                <div className="inputs input-groups">
                                                                                    <InputGroup className="">
                                                                                        <FormControl type="text" placeholder="Enter subname" value={new Date(parseInt(this.state.formdata?.startDate) * 10000).toLocaleString()} readOnly
                                                                                        />
                                                                                    </InputGroup>
                                                                                    {/* <span className="text-danger f-12 d-block text-left">sdasdas</span> */}
                                                                                </div>
                                                                            </div>

                                                                            <div className='col-md-6 mb-4'>
                                                                                <p className='input_desc_sm'>End date</p>
                                                                                <div className="inputs input-groups">
                                                                                    <InputGroup className="">
                                                                                        <FormControl type="text" placeholder="Enter subname" value={new Date(parseInt(this.state.formdata?.endDate) * 10000).toLocaleString()} readOnly
                                                                                        />
                                                                                    </InputGroup>
                                                                                    {/* <span className="text-danger f-12 d-block text-left">sdasdas</span> */}
                                                                                </div>
                                                                            </div>

                                                                            <div className='col-md-6 mb-4'>
                                                                                <p className='input_desc_sm'>For vote</p>
                                                                                <div className="inputs input-groups">
                                                                                    <InputGroup className="">
                                                                                        <FormControl type="text" placeholder="Enter subname" value={parseInt(this.state.formdata?.forVotes)} readOnly
                                                                                        />
                                                                                    </InputGroup>
                                                                                    {/* <span className="text-danger f-12 d-block text-left">sdasdas</span> */}
                                                                                </div>
                                                                            </div>

                                                                            <div className='col-md-6 mb-4'>
                                                                                <p className='input_desc_sm'>Against vote</p>
                                                                                <div className="inputs input-groups">
                                                                                    <InputGroup className="">
                                                                                        <FormControl type="text" placeholder="Enter subname" value={parseInt(this.state.formdata?.againstVotes)} readOnly
                                                                                        />
                                                                                    </InputGroup>
                                                                                    {/* <span className="text-danger f-12 d-block text-left">sdasdas</span> */}
                                                                                </div>
                                                                            </div>

                                                                            <div className='col-md-6 mb-4'>
                                                                                <p className='input_desc_sm'>Abstaint vote</p>
                                                                                <div className="inputs input-groups">
                                                                                    <InputGroup className="">
                                                                                        <FormControl type="text" placeholder="Enter subname" value={parseInt(this.state.formdata?.abstainVotes)} readOnly
                                                                                        />
                                                                                    </InputGroup>
                                                                                    {/* <span className="text-danger f-12 d-block text-left">sdasdas</span> */}
                                                                                </div>
                                                                            </div>

                                                                        </div>

                                                                        <div className='col-12 col-md-12 px-1 text-center'>
                                                                            {this.state.formdata?.status == 0 && <button className="get-started-btn mt-2" onClick={this.ApproveVoting}>
                                                                                Approve
                                                                            </button>}

                                                                            {this.state.formdata?.status == 1 && <button className="get-started-btn mt-2" onClick={this.FinalisedVoting}>
                                                                                Finalise
                                                                            </button>}
                                                                           

                                                                        </div>
                                                                    </Tab.Pane>
                                                                </Tab.Content>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Tab.Container>
                                            </div>
                                        </div>


                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
        )
    }
}

export default Proposaledit



